package com.example.borshi.web.nutritionist.ui.theme

import org.jetbrains.compose.web.css.*

/**
 * Design System Tokens - Single Source of Truth for styling
 * Following 8pt spacing system and modern enterprise design patterns
 */

// ============== SPACING SYSTEM (8pt Grid) ==============
object Spacing {
    val xs = 4.px
    val sm = 8.px
    val md = 16.px
    val lg = 24.px
    val xl = 32.px
    val xxl = 40.px
    val xxxl = 48.px
}

// ============== TYPOGRAPHY SCALE ==============
object Typography {
    // Sizes
    val pageTitle = 32.px
    val sectionTitle = 20.px
    val subsectionTitle = 18.px
    val body = 16.px
    val bodySmall = 14.px
    val caption = 13.px
    val tiny = 12.px

    // Weights
    const val regular = "400"
    const val medium = "500"
    const val semibold = "600"
    const val bold = "700"

    // Line Heights
    const val tight = "1.25"
    const val normal = "1.5"
    const val relaxed = "1.75"
}

// ============== COLOR PALETTE ==============
object ColorTokens {
    // Primary Brand
    val primary = Color("#2563EB")
    val primaryHover = Color("#1D4ED8")
    val primaryActive = Color("#1E40AF")
    val primaryLight = Color("#DBEAFE")

    // Semantic Colors
    val success = Color("#16A34A")
    val successLight = Color("#DCFCE7")
    val warning = Color("#F59E0B")
    val warningLight = Color("#FEF3C7")
    val danger = Color("#DC2626")
    val dangerLight = Color("#FEE2E2")
    val info = Color("#0EA5E9")
    val infoLight = Color("#E0F2FE")

    // Surfaces (Light Mode)
    val surface = Color("#FFFFFF")
    val surfaceMuted = Color("#F8FAFC")
    val surfaceHover = Color("#F1F5F9")
    val surfaceActive = Color("#E2E8F0")

    // Borders
    val border = Color("#E2E8F0")
    val borderMuted = Color("#F1F5F9")
    val borderFocus = Color("#2563EB")

    // Text
    val textPrimary = Color("#0F172A")
    val textSecondary = Color("#475569")
    val textTertiary = Color("#94A3B8")
    val textInverse = Color("#FFFFFF")

    // Overlays
    const val overlayDark = "rgba(15, 23, 42, 0.6)"
    const val shadowSm = "0 1px 2px 0 rgba(0, 0, 0, 0.05)"
    const val shadowMd = "0 4px 6px -1px rgba(0, 0, 0, 0.1)"
    const val shadowLg = "0 10px 15px -3px rgba(0, 0, 0, 0.1)"
    const val shadowXl = "0 20px 25px -5px rgba(0, 0, 0, 0.1)"
}

// ============== BORDER RADIUS ==============
object BorderRadius {
    val sm = 4.px
    val md = 6.px
    val lg = 8.px
    val xl = 12.px
    val xxl = 16.px
    val full = 9999.px
}

// ============== TRANSITIONS ==============
object Transitions {
    const val fast = "120ms ease-in-out"
    const val normal = "200ms ease-in-out"
    const val slow = "300ms ease-in-out"
}

// ============== Z-INDEX LAYERS ==============
object ZIndex {
    const val base = "0"
    const val dropdown = "1000"
    const val sticky = "1100"
    const val overlay = "1200"
    const val modal = "1300"
    const val tooltip = "1400"
}

// ============== ICON SIZES ==============
object IconSize {
    val xs = 14.px
    val sm = 16.px
    val md = 20.px
    val lg = 24.px
    val xl = 32.px
}

// ============== BREAKPOINTS ==============
object Breakpoints {
    const val mobile = "768px"
    const val tablet = "1024px"
    const val desktop = "1280px"
}

